import React, { useState ,useEffect,useRef} from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  IconButton,
  Button,
  InputBase,
  Select,
  Menu,
  MenuItem,
  Pagination,
  TablePagination,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import CustomText, { textStyles } from "../../../../components/CustomText";
import arrow from "../../../../assets/arrow.svg";
import invited from "../../../../assets/Dashboard/invited.svg";
import tablefilter from "../../../../assets/tablefilter.svg";
import clienttrial from "../../../../assets/Dashboard/clienttrial.svg";
import ClientsTrialDetails from './ClientTrialDetails';
import ExportClientTrialsPDF from './TrialPDF';
import { pdf } from '@react-pdf/renderer';
import { CircularProgress } from '@mui/material';
import FilterDrawer from "./FilterDrawer";
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from "../../../../components/BaseUrl"
import { decryptToken } from "../../../../Utlis/Encryption";
import {toast,Toaster} from "react-hot-toast";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg"
import dummy from "../../../../assets/dummy.png";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowStatusDropdown from '../../../../components/ArrowStatusDropdown';
import ExportClientTrialsExcel from './TrialExcel';
import TrialClientsPins from "./ClientsTrialPins"
import { useNavigate } from "react-router-dom";
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";

const ClientsTrial= () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1); 
const [totalItems, setTotalItems] = useState(0);
  const rowsPerPage = 6;
const [originalRows, setOriginalRows] = useState([]);
const [sortLoading, setSortLoading] = useState(false);
 const [tableProcessing, setTableProcessing] = useState(false);
const [loading, setLoading] = useState(false);
const [selectedClientId, setSelectedClientId] = useState(null);
  const rawEncryptedToken = localStorage.getItem("token")
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null
  const planNameMap = {
  attendance_yearly: "Attendance Yearly",
  attendance_monthly: "Attendance Monthly",
  full_monthly: "Full Monthly",
  full_yearly: "Full Yearly",
};
  const handleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

const HaederStyles = {
  color: "#44546F",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,
  textAlign:"center"

};
const DataStyles = {
  color: "#172B4D",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};
const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
const [filters, setFilters] = useState({
  subscription_plan: '',
  subscription_status: '',
  status: '',
  verification_status: '',
  start_date: '',
  end_date: ''
});

const INITIAL_FILTERS = {
  subscription_plan: '',
  subscription_status: '',
  status: '',
  verification_status: '',
  start_date: '',
  end_date: ''
};
const fetchTrialClients = async ({
  setLoading,
  setOriginalRows,
  setTableRows,
  token,
  page,
  rowsPerPage,
  search = '',
  filters = {}
}) => {
  console.log("📤 Filters from Drawer:", filters);
  const isInitialLoad = !firstLoadDone;
  if (isInitialLoad) setLoading(true); else setTableProcessing(true);

  try {
    const queryParams = new URLSearchParams({
      page: page + 1,
      limit: rowsPerPage,
      sort_by: sortConfig.key || 'created_at',
      sort_order: sortConfig.direction?.toUpperCase() || 'DESC',
    });

    if (search) queryParams.append('search', search);
    if (filters.subscription_plan) queryParams.append('subscription_plan', filters.subscription_plan);
    if (filters.subscription_status) queryParams.append('subscription_status', filters.subscription_status);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.verification_status && filters.verification_status !== 'all') queryParams.append('verification_status', filters.verification_status);
    if (filters.start_date) queryParams.append('start_date', filters.start_date);
    if (filters.end_date) queryParams.append('end_date', filters.end_date);
if (filters.country) queryParams.append("country", filters.country);
if (filters.province) queryParams.append("state", filters.province);
if (filters.city) queryParams.append("city", filters.city);

if (filters.trial_end_date_from)
  queryParams.append("trial_end_date_from", filters.trial_end_date_from);

if (filters.trial_end_date_to)
  queryParams.append("trial_end_date_to", filters.trial_end_date_to);

if (filters.subscription_start_date_from)
  queryParams.append("subscription_start_date_from", filters.subscription_start_date_from);

if (filters.subscription_start_date_to)
  queryParams.append("subscription_start_date_to", filters.subscription_start_date_to);
    const finalUrl = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    console.log('🔎 API URL:', finalUrl);

    const response = await fetch(finalUrl, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    console.log('📥 API Response:', result);

    if (!result.error) {
      const companyAdmins = result.data.company_admins || [];
      console.log(`✅ Filtered Result Length: ${companyAdmins.length}`);
const formatRange = (start, end) => {
  if (!start && !end) return "-";

  const format = (d) =>
    d
      ? convertUTCToLocalDateTime(d, {
          formatOptions: {
            day: "2-digit",
            month: "short",
            year: "numeric",
          },
        })
      : "-";

  return `${format(start)} - ${format(end)}`;
};
      const formattedData = companyAdmins.map(item => ({
        id: item.id,
        admin: item.full_name,
        company: item.company_name,
        country: item.country,
        email: item.email,
        subscriptionStatus: 'trial', // Hardcoded to 'trial'
        subscription: planNameMap[item.subscription_plan] || item.subscription_plan,
        maxUsers: item.max_employees,
        phone: item.phone,
        expirydate: convertUTCToLocalDateTime(item.trial_end_date),
        status: item.status,
        verificationStatus: item.verification_status,
              active: item.current_employees,
        users: item.max_employees,
        active: item.current_employees,
        businessEmail: item.business_email,
      date: convertUTCToLocalDateTime(item.registered),
            subscriptionPeriod: formatRange(
    item.subscription_start_date,
    item.subscription_end_date
  ),

  trialPeriod: formatRange(
    item.trial_start_date,
    item.trial_end_date
  ),
      }));

      setOriginalRows(formattedData);
      setTableRows(formattedData);
      setTotalPages(result.data.pagination.pages);
      setTotalItems(result.data.pagination.total);
    } else {
      throw new Error(result.message);
    }
  } catch (error) {
    toast.error(error.message || 'Failed to load data');
    console.error('❌ Fetch Error:', error);
  } finally {
    setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true);
  }
};
  const isFilterApplied = Object.values(filters).some(f => f && f !== '');

// useEffect(() => {
//   fetchTrialClients({
//     setLoading,
//     setOriginalRows,
//     setTableRows,
//     token
//   });
// }, []);
const [searchTerm, setSearchTerm] = useState('');
const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}
const debouncedSearch = useDebounce(searchTerm, 500);
useEffect(() => {
  fetchTrialClients({
    setLoading: sortLoading ? () => {} : setLoading,
    setOriginalRows,
    setTableRows,
    token,
    page,
    rowsPerPage,
    search: debouncedSearch,
    filters  

  }).finally(() => {
    setSortLoading(false);
  });
}, [page, rowsPerPage, sortConfig, debouncedSearch, filters]);
      const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

      const [tableRows, setTableRows] = useState(originalRows);
  const statusButtonStyles = {
    verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
    active: { backgroundColor: '#4BCE97', color: '#164B35'},
    inactive: { backgroundColor: ' #F87168', color: '#5D1F1A' },
    blocked: { backgroundColor: '#F87168', color: '#5D1F1A' },
    rejected: { backgroundColor: '#D32F2F', color: '#FFFFFF' },
      requested: {  backgroundColor: '#F5CD47', color: '#533F04'  },
         invited: { backgroundColor: '#579DFF', color: '#09326C' },
            pending: { backgroundColor: '#F5CD47', color: '#533F04' },
  };

const columns = [
  { key: 'id', label: t('clientsTrial.id') },
  { key: 'admin', label: t('clientsTrial.companyAdmin') },
  { key: 'company', label: t('clientsTrial.companyLegalName') },
  { key: 'country', label: t('clientsTrial.country') },
   { key: 'active', label: t("activeUsers") },
    { key: 'Users', label: t("maxUsers") },
  { key: 'email', label: t("ClientsRequests.columns.email") },
   { key: 'subscription', label: t("subscriptionPlan") },
     { key: 'subscriptionStatus', label: t('subscriptionStatus') },
  { key: 'date', label: t('DateTime') },
  { key: 'subscriptionPeriod', label: t("subscriptionPeriod") },
{ key: 'trialPeriod', label: t("trialPeriod") },
  { key: 'status', label: t('clientsTrial.status') },
  //  {key: 'verificationStatus', label: t("invites.columns.verificationStatus") },
  // {key:'subscriptionStatus',label:t("InviteDetails.subscriptionStatus")},
  //  { key: 'expirydate', label: t('clientsTrial.expiryDate') },
 
  { key: 'action', label: t('clientsTrial.action') }
];
// const [originalRows, setOriginalRows] = useState(data); // master source

// const handleSort = (key) => {
//   const direction =
//     sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
//   setSortConfig({ key, direction });
// };
const handleSort = (key) => {
  const direction =
    sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
  setSortConfig({ key, direction });
  setSortLoading(true);
};
// const filteredRows = originalRows.filter(row =>
//   row.admin.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   row.company.toLowerCase().includes(searchTerm.toLowerCase())
// );
const filteredRows = originalRows;

const sortedRows = [...filteredRows].sort((a, b) => {
  const { key, direction } = sortConfig;
  if (!key || key === 'action') return 0;
  const aVal = a[key]?.toString().toLowerCase() || '';
  const bVal = b[key]?.toString().toLowerCase() || '';
  return direction === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
});
// const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
const paginatedRows = tableRows;

const allSelected = tableRows.length > 0 && selected.length === tableRows.length;
const isIndeterminate = selected.length > 0 && !allSelected;
const [statusUpdating, setStatusUpdating] = useState(null); // add with your state
const handleStatusUpdate = async (status) => {
  if (selected.length === 0) return;
  setStatusUpdating(status);

  const payload = {
    company_admin_ids: selected,
    status: status,
    verification_status: 'verified',
  };

  try {
    const res = await fetch(`${BASE_URL}/company-admins/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();

    if (!result.error) {
      toast.success(`Status updated to "${status}"`);
      const updated = tableRows.map((row) =>
        selected.includes(row.id) ? { ...row, status } : row
      );
      setTableRows(updated);
      setSelected([]);
    } else {
      toast.error(result.message || 'Failed to update status');
    }
  } catch (err) {
    toast.error('Something went wrong while updating status.');
  } finally {
    setStatusUpdating(null);
  }
};
const statusValues = ['active', 'inactive', 'invited', 'requested'];
const statusOptions = statusValues.map((value) => ({
  label: t(`statusOptions.${value}`),
  value,
}));





const menuAnchorsRef = useRef({});
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);
const selectedRowFromMenu = tableRows.find((r) => r.id === menuRowId);

const handleMessagesClick = () => {
  if (!menuRowId) return;

  const selectedCompanyAdmin = tableRows.find((row) => row.id === menuRowId);
  if (selectedCompanyAdmin) {
    const navigationState = {
      openChatWith: {
        id: selectedCompanyAdmin.id,
        name: selectedCompanyAdmin.admin,
        email: selectedCompanyAdmin.email,
      },
      chatType: "company_admin",
    };
    navigate("/messages", { state: navigationState });
  }
  setAnchorEl(null);
  setMenuRowId(null);
};


// const handleViewClick = async () => {
//  setSelectedRow(row)
// };

// true if any filter set

const clearFilters = () => {
  const clearedFilters = {
    subscription_plan: '',
    subscription_status: '',
    status: '',
    verification_status: '',
    start_date: '',
    end_date: ''
  };
  setFilters(clearedFilters);
  setPage(0);
};

const fetchAllTrialClients = async () => {
  const queryParams = new URLSearchParams({
    no_pagination: "true",
    sort_by: sortConfig.key || "created_at",
    sort_order: sortConfig.direction?.toUpperCase() || "DESC",
  });

  if (searchTerm) queryParams.append("search", searchTerm);
  if (filters.subscription_plan)
    queryParams.append("subscription_plan", filters.subscription_plan);
  if (filters.subscription_status)
    queryParams.append("subscription_status", filters.subscription_status);
  if (filters.status) queryParams.append("status", filters.status);
  if (filters.start_date) queryParams.append("start_date", filters.start_date);
  if (filters.end_date) queryParams.append("end_date", filters.end_date);

  const finalUrl = `${BASE_URL}/company-admins?${queryParams.toString()}`;
  const res = await fetch(finalUrl, {
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
  });
  const result = await res.json();

  if (result.error) {
    toast.error(result.message || "Failed to fetch trial clients");
    return [];
  }

  const admins = result?.data?.company_admins || [];

  return admins.map((item) => ({
    id: item.id,
    admin: item.full_name,
    company: item.company_name,
    country: item.country,
    email: item.email,
    subscriptionStatus: 'trial', // Hardcoded to 'trial'
    subscription: item.subscription_plan,
    maxUsers: item.max_employees,
    phone: item.phone,
    expirydate: new Date(item.trial_end_date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
    status: item.status,
    verificationStatus: item.verification_status,
    users: item.max_employees,
    businessEmail: item.business_email,
    date: new Date(item.registered).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  }));
};

const mapFilters = {
  verification_status: filters.verification_status,
  start_date: filters.start_date,
  end_date: filters.end_date,
  status: filters.status,
   country: filters.country,
  state: filters.province,
  city: filters.city,
   trial_end_date_from: filters.trial_end_date_from,
  trial_end_date_to: filters.trial_end_date_to,
    subscription_status: filters.subscription_status,

  subscription_start_date_from: filters.subscription_start_date_from,
  subscription_start_date_to: filters.subscription_start_date_to,
};
  return (
    <Box sx={{ py:2,px:1}}>
     
      <Toaster/>
      {/* {selectedRow ? (
  <ClientsTrialDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
) : ( */}
  {loading ? (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 120px)',
    }}
  >
    <CircularProgress sx={{ color: '#006EC2' }} size={40} thickness={4} />
  </Box>
) : selectedRow ? (
  <ClientsTrialDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
) : (
<>

  <Box sx={{mb:2,}}>
            <TrialClientsPins selectedClientId={selectedClientId}
             onClearClientId={() => setSelectedClientId(null)} 
               filters={mapFilters}
  page={page}
  limit={rowsPerPage}
  search={debouncedSearch}/>
            </Box>

            
      <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>
<Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    mb: 2,
    flexWrap: 'wrap',
    rowGap: 1,
  }}
>

  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
  <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
    {t('clientsTrial.manageClients')}
  </CustomText>
{tableProcessing && (
    <CircularProgress size={18} thickness={4} sx={{ color: '#006EC2' }} />
  )}
</Box>

         <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap',
                    flexGrow: 1,
                    justifyContent: selected.length === 0 ? 'center' : 'flex-end',
                  }}
                >
  {selected.length > 0
    ? statusOptions.map(({ label, value }) => (
    <Button
          key={label}
          onClick={() => handleStatusUpdate(value)}
          variant="contained"
          size="small"
          sx={{
            px: 2,
            height: 34,
            fontSize: 13,
            fontWeight: 400,
            fontFamily: 'Poppins, sans-serif',
            borderRadius: '4px',
            textTransform: 'none',
            backgroundColor: statusButtonStyles[value]?.backgroundColor,
            color: statusButtonStyles[value]?.color,
            '&:hover': {
              backgroundColor: statusButtonStyles[value]?.backgroundColor,
              opacity: 0.9,
            },
          }}
        >
           {statusUpdating === value && (
            <CircularProgress
              size={16}
              thickness={4}
              sx={{ color: statusButtonStyles[value]?.color, mr: 1 }}
            />
          )}
          {label}
        </Button>
      ))
    : (
                      <>
                        <Box
                          sx={{
                            mx: 'auto',
                            px: 0.5,
                            py: 0.2,
                            borderRadius: 1,
                            height: 34,
                            border: '2px solid #091E4224',
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: 250,
                          }}
                        >
                          <InputBase
                          placeholder={t('adminNameEmail')}
                              value={searchTerm}
    onChange={(e) => {
      setSearchTerm(e.target.value);
      setPage(0);
    }}
                            sx={{ ml: 0.5, fontSize: 15, letterSpacing: '0px',
                                    fontFamily: 'Poppins, sans-serif',
                               color: '#939393', fontWeight: 400, width: '100%' }}
                          />
                          <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
                        </Box>
<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllTrialClients(); // 👈 fetch all filtered results
    const blobStream = pdf(<ExportClientTrialsPDF data={allData} />).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Client_Trials_${new Date().toISOString().slice(0,10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllTrialClients(); // 👈 fetch all filtered results
    ExportClientTrialsExcel(allData);
  }}
/>
                    


    {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#006EC2", // blue background when filter applied
    }}
  >
    {/* Filter Icon */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Small Cross Badge */}
    <IconButton
      size="small"
      onClick={clearFilters}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      backgroundColor: "white",
      color: "#5E5C5C",
      "&:hover": { backgroundColor: "#F2F2F2" },
    }}
  >
    <FilterAltIcon sx={{ fontSize: 22 }} />
  </IconButton>
)}
    
                      </>
                    )}
                </Box>
</Box>

        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table size="small">
            <TableHead  sx={{
                whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
            }}>
         
                <TableRow>

    {columns.map((col) => (
      <TableCell
        key={col.key}
        sx={{ ...HaederStyles, py: '6px', px: '2px', textAlign: col.key === 'status' ? 'center' : 'center',
          pl: col.key === 'id' ? '10px' : '2px'
         }}
      >
        <Box sx={{  display: 'flex',
    justifyContent: 'center',   // <-- centers the whole header content
    alignItems: 'center',
    gap: 0.3,
    width: '100%'    }}>
          {col.label}
          {col.key !== 'action' && (
            <IconButton size="small" onClick={() => handleSort(col.key)}>
              {sortConfig.key === col.key && sortConfig.direction === 'asc' ? (
                <NorthIcon sx={{ fontSize: '12px' }} />
              ) : (
                <SouthIcon sx={{ fontSize: '12px' }} />
              )}
            </IconButton>
          )}
        </Box>
      </TableCell>
    ))}
  </TableRow>
            </TableHead>
 



            <TableBody>
  {paginatedRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length + 1}>
         <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptyscreen} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('empty.no_user')}
  </CustomText>

        </Box>
      </TableCell>
    </TableRow>
  ) : (
    paginatedRows.map((row, index) => (
      <TableRow key={row.id} hover onClick={() => setSelectedClientId(row.id)} sx={{ cursor: 'pointer' }}>
        {/* <TableCell padding="checkbox">
          <Checkbox
            checked={selected.includes(row.id)}
            onChange={() => handleSelect(row.id)}
          />
        </TableCell> */}
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px',pl:1 }}>{row.id}</TableCell>
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}><CustomText sx={{ fontSize: 13, fontWeight: 500, color: "#172B4D",  fontFamily: 'Poppins, sans-serif' }}>
      {row.admin || "-- "}
    </CustomText>

    <CustomText sx={{ fontSize: 12, fontWeight: 400, color: "#5A5A5A",  fontFamily: 'Poppins, sans-serif' }}>
      {row.email || "-- "}
    </CustomText></TableCell>
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.company || "-- "}</TableCell>
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.country || "-- "}</TableCell>
                <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.active || "-- "}</TableCell>
           <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.users || "-- "}</TableCell>
              <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.businessEmail || "-- "}</TableCell>
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>
          {Array.isArray(row.subscription)
            ? row.subscription.join(", ")
            : String(row.subscription).replace(/[\[\]{}"]/g, "")}
        </TableCell>
        <TableCell sx={{ ...DataStyles, width: 120 , textTransform: "capitalize" }}>
          {row?.subscriptionStatus?.replace(/_/g, " ")}
        </TableCell>
        <TableCell sx={{ ...DataStyles, py: '6px', px: '4px' }}>{row.date}</TableCell>
        <TableCell sx={{ ...DataStyles, width: 220 }}>
          {row.subscriptionPeriod}
        </TableCell>
        <TableCell sx={{ ...DataStyles, width: 220 }}>
          {row.trialPeriod}
        </TableCell>
        <TableCell>
            <Box sx={{ pointerEvents: "none" }}>
          <StatusDropdown
            // statusOptions={["Active", "Inactive", "Requested", "Invited"]}
            currentStatus={row.status}
            onChange={(newStatus) => {
              const updated = [...tableRows];
              updated[page * rowsPerPage + index].status = newStatus;
              setTableRows(updated);
            }}
          />
          </Box>
        </TableCell>
        {/* <TableCell>
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.subscriptionStatus} />
          </Box>
        </TableCell> */}
        <TableCell>
          <IconButton
            ref={(el) => {
              if (el) menuAnchorsRef.current[row.id] = el;
            }}
            onClick={() => {
              setAnchorEl(menuAnchorsRef.current[row.id]);
              setMenuRowId(row.id);
            }}
          >
            <MoreVertIcon fontSize="small" sx={{ fontSize: "22px" }} />
          </IconButton>
        </TableCell>
      </TableRow>
    ))
  )}
</TableBody>


          </Table>
        </TableContainer>

                                                 <Menu
                   sx={{fontSize:"15px",boxShadow:"none"}}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
                    PaperProps={{
                    sx: {
                      // minWidth: 80,
                      // paddingY: 0.5,
                      // boxShadow:"none",
                      // border: '1px solid #E0E0E0',
                    },
                  }}
                  MenuListProps={{
                    sx: {
                      paddingY: 0,
                    },
                  }}
                >
                  <MenuItem    onClick={() => {
    setSelectedRow(selectedRowFromMenu); // ✅ same as icon onClick
    setAnchorEl(null); // ✅ close menu
    setMenuRowId(null); // ✅ cleanup
  }}
  sx={{fontSize:"14px",
                       fontFamily: 'Poppins, sans-serif',
                  }}>{t("common.view")}</MenuItem>

             <MenuItem
             onClick={handleMessagesClick}
             sx={{fontSize:"14px",
                   fontFamily: 'Poppins, sans-serif',
              }}>{t("messages")}</MenuItem>
                </Menu>



             <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
            <Pagination
  count={totalPages}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  shape="rounded"
  color="primary"
  size="small"
  sx={{
    '& .MuiPaginationItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 13,
      fontWeight: 500,
    },
    '& .Mui-selected': {
      backgroundColor: '#E9F3FF',
      color: '#006EC2',
    },
  }}
/>
</Box>
      </Box>
      </>
      )}
      
<FilterDrawer
  open={filterDrawerOpen}
  onClose={() => setFilterDrawerOpen(false)}
  filters={filters}
  setFilters={setFilters}
onApplyFilters={(updatedFilters) => {
  setFilters(updatedFilters);
  setPage(0); // ✅ always reset to first page
  setFilterDrawerOpen(false);
}}
/>
    </Box>

  );
};

export default ClientsTrial;






